<div class="tag-inputs flex flex-col">
  <div class="tag-preview">
    <tag class="mat-small" [color]="colorControl.value" [text]="nameControl.value" />
  </div>
  <div class="flex flex-row flex-wrap items-center justify-start gap-2">
    <mat-form-field class="flex-grow">
      <mat-label i18n>Tag Name</mat-label>
      <input matInput #nameInput (keyup.enter)="enterKeyPressed()" [formControl]="nameControl" />
      @if (nameControl.errors?.required) {
        <mat-error i18n>Required</mat-error>
      } @else if (nameControl.errors?.archivedNotAllowed) {
        <mat-error i18n>Archived tag not allowed</mat-error>
      } @else if (nameControl.errors?.tagAlreadyExists) {
        <mat-error i18n>Tag already exists</mat-error>
      }
    </mat-form-field>
    <mat-form-field class="color-input">
      <mat-label i18n>Color</mat-label>
      <input matInput (keyup.enter)="enterKeyPressed()" [formControl]="colorControl" />
      @if (colorControl.errors?.required) {
        <mat-error i18n>Required</mat-error>
      }
    </mat-form-field>
  </div>
</div>
<div class="flex flex-col flex-wrap md:flex-row justify-start md:items-center gap-2">
  <color-chooser [chosenColor]="colorControl.value" (chooseColorEvent)="chooseColor($event)" />
  <span class="flex-auto"></span>
  <div class="flex gap-2 justify-end">
    <button mat-button (click)="close()" i18n>Cancel</button>
    <button
      mat-flat-button
      color="primary"
      [disabled]="!nameControl.valid || !colorControl.valid"
      (click)="submit()"
    >
      {{ submitLabel }}
    </button>
  </div>
</div>
